import React from 'react';

import {
  Box,
  Center,
  HStack,
  PinInput,
  PinInputField,
  PinInputFieldProps,
  PinInputProps,
  Text,
  VStack,
} from '@chakra-ui/react';
import { disableScrollingOnce } from 'app/utils/utils';

interface TokenInputProps extends Partial<PinInputProps> {
  error?: string;
}

const pinInputFieldProps: PinInputFieldProps = {
  borderRadius: 4,
  bg: 'M.20',
  color: 'M.70',
  borderColor: 'M.30',
  _focus: {
    borderColor: 'M.60',
    boxShadow: 'none',
  },
  // Prevent scroll into input on touch
  onTouchStart: (e) => {
    e.preventDefault();
    Object.assign(e.currentTarget.readOnly, true);
    disableScrollingOnce();
  },
  onTouchEnd: (e) => {
    e.preventDefault();
    Object.assign(e.currentTarget.readOnly, false);
    e.currentTarget.focus({ preventScroll: true });
  },
};

export const TokenInput = ({ error, ...pinInputProps }: TokenInputProps) => {
  const separator = (
    <Center border="none" w={6}>
      <Box
        w={2}
        h={0.5}
        bg="M.70"
        _focus={{ borderColor: 'M.60', boxShadow: 'none' }}
      />
    </Center>
  );

  return (
    <VStack w="full" align="start" h="70px" spacing={0}>
      <HStack w="full" spacing="auto" align="center">
        <PinInput
          autoFocus
          otp
          type="number"
          placeholder="-"
          {...pinInputProps}
        >
          <PinInputField {...pinInputFieldProps} data-testid="token-input" />
          <PinInputField {...pinInputFieldProps} />
          <PinInputField {...pinInputFieldProps} />
          {separator}
          <PinInputField {...pinInputFieldProps} />
          <PinInputField {...pinInputFieldProps} />
          <PinInputField {...pinInputFieldProps} />
        </PinInput>
      </HStack>

      {error && (
        <Text w="fit-content" pl={3} color="R.80" fontSize="xs">
          {error}
        </Text>
      )}
    </VStack>
  );
};
